<template>
  <div class="tag-input-wrap">
    <el-tag
      v-for="tag in tags"
      :key="tag"
      closable
      size="small"
      :disable-transitions="false"
      @close="onRemove(tag)">
      {{ tag }}
    </el-tag>
    <el-input
      v-if="inputVisible"
      ref="tagInputRef"
      v-model="inputValue"
      size="mini"
      class="tag-input"
      @blur="handleInputConfirm"
      @keyup.enter="handleInputConfirm">
    </el-input>
    <el-button
      v-else
      class="button-new-tag"
      size="mini"
      icon="el-icon-plus"
      @click="showInput">添加标签</el-button>
  </div>
</template>

<script>
export default {
  name: 'TagInput',
  props: {
    tags: { type: Array, default: () => [] },
    vid: { type: String, required: true },
    userID: { type: String, required: true }
  },
  emits: ['add', 'remove'],
  data() {
    return {
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.tagInputRef && this.$refs.tagInputRef.focus();
      });
    },
    handleInputConfirm() {
      const val = this.inputValue.trim();
      if (val) {
        this.$emit('add', { vid: this.vid, userID: this.userID, tag: val });
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    onRemove(tag) {
      this.$emit('remove', { vid: this.vid, userID: this.userID, tag: tag });
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-input-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 8px 0;
}
.tag-input {
  width: 100px;
}
.button-new-tag {
  height: 24px;
  padding: 0 8px;
  font-size: 12px;
}
</style>
